export const THEMES = [
  { id: 'emeraude', label: 'Émeraude Labo', desc: 'Le néon signature TerraFungi', neon: '16 185 129', cyber: '6 182 212', violet: '139 92 246' },
  { id: 'cyber', label: 'Cyber Cyan', desc: 'Futur froid, terminal bleuté', neon: '6 182 212', cyber: '16 185 129', violet: '139 92 246' },
  { id: 'violet', label: 'Bio Violet', desc: 'Génétique et ultraviolet', neon: '139 92 246', cyber: '34 211 238', violet: '16 185 129' },
  { id: 'ambre', label: 'Ambre Spore', desc: 'Chaleur de forêt d\'automne', neon: '245 158 11', cyber: '16 185 129', violet: '249 115 22' },
  { id: 'corail', label: 'Corail Sauvage', desc: 'Pleurote rose électrique', neon: '244 63 94', cyber: '251 146 60', violet: '168 85 247' },
  { id: 'glacial', label: 'Blanc Glacial', desc: 'Salle blanche minimaliste', neon: '226 232 240', cyber: '148 163 184', violet: '125 211 252' },
];

export const hexToTriplet = (hex) => {
  const h = hex.replace('#', '');
  return [0, 2, 4].map((i) => parseInt(h.slice(i, i + 2), 16)).join(' ');
};

export const tripletToHex = (triplet) => {
  if (!triplet) return '#10B981';
  const parts = triplet.trim().split(/\s+/).map(Number);
  return '#' + parts.map((n) => Math.max(0, Math.min(255, n)).toString(16).padStart(2, '0')).join('');
};

export const applyThemeVars = ({ neon, cyber, violet }) => {
  const root = document.documentElement.style;
  if (neon) root.setProperty('--neon', neon);
  if (cyber) root.setProperty('--cyber', cyber);
  if (violet) root.setProperty('--bioviolet', violet);
};

export const resetThemeVars = () => {
  const root = document.documentElement.style;
  root.removeProperty('--neon');
  root.removeProperty('--cyber');
  root.removeProperty('--bioviolet');
};

export const scaleTriplet = (triplet, factor) =>
  triplet.trim().split(/\s+/).map((n) => Math.round(Math.max(0, Math.min(255, Number(n) * factor)))).join(' ');

export const applyMode = (mode) => {
  document.documentElement.setAttribute('data-mode', mode || 'dark');
};

export const LIGHT_ACCENT_FACTOR = 0.72;

export const resolveTheme = (content) => {
  if (!content) return null;
  if (content.neon) {
    const preset = THEMES.find((t) => t.id === content.preset) || THEMES[0];
    return { neon: content.neon, cyber: content.cyber || preset.cyber, violet: content.violet || preset.violet };
  }
  return THEMES.find((t) => t.id === content.preset) || null;
};
